<template>
  <div class="logistics">
    <div>
      <e-dialog
        :close-on-click-modal="false"
        title="查看物流"
        :visible.sync="realShow"
        center
        top="50px"
        width="520px"
        :before-close="handleRealShow"
      >
        <div v-loading="loading">
          <header class="flex-start">
            <div class="goods-inf">
              <img :src="orderItems.img" />
              <p>{{ orderItems.number }}件商品</p>
            </div>
            <div class="express">
              <p><span class="fw-500">配送企业:</span>{{ orderItems.expressName }}</p>
              <p class="margin-top5"><span class="fw-500">快递单号:</span>{{ orderItems.expressNum }}</p>
            </div>
          </header>
          <div class="detail-y">
            <div class="list-item flex-start" v-for="(item, index) in list" :key="index">
              <div class="flex-column">
                <div class="dot" :class="{ active: index === 0 }"></div>
                <div class="line flex-grow" v-if="index < list.length - 1"></div>
              </div>
              <div>
                <p class="title">{{ item.acceptStation }}</p>
                <p class="time">{{ item.acceptTime }}</p>
              </div>
            </div>
          </div>
          <div class="btn confirm" @click="handleRealShow">确定</div>
        </div>
      </e-dialog>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'element-ui'
import orderApi from '@/api/order'
export default {
  name: 'logisticsBox',
  components: {
    EDialog: Dialog
  },
  props: {
    orderItems: {
      default: null
    }
  },
  data() {
    return {
      realShow: false,
      activeIndex: -1,
      show: false,
      express: {},
      loading: false,
      list: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleRealShow() {
      this.realShow = false
      this.$emit('handleRealShow', this.realShow)
    },
    getData() {
      this.$nextTick(() => {
        const params = {
          orderItemId: this.orderItems.orderItemId
        }
        orderApi.getLogistics(params).then(
          (res) => {
            this.list = JSON.parse(res.data).traces
          },
          (res) => {
            this.$feedback(res.message)
          }
        )
      })
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {
          this.getData()
          this.realShow = true
          this.show = false
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.flex-align {
  display: flex;
  align-items: center;
  width: 100%;
}

.flex-start {
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.sp {
  justify-content: space-between;
}

.flex-grow {
  flex-grow: 1;
  text-align: center;
}

.margin-top5 {
  margin-top: 5px;
}
.fw-500 {
  font-weight: 500;
}

.logistics {
  color: #333;
  font-size: 16px;
  .express {
    padding: 3px 25px;
    font-size: 20px;
    color: #333;
  }
  & ::v-deep {
    .el-dialog__header {
      padding: 30px;
      font-size: 20px;
    }
    .el-dialog__body {
      padding: 0 0 40px;
    }
    .el-message {
      z-index: 3008;
    }
  }

  header {
    padding: 0 40px;
  }
  .goods-inf {
    position: relative;
    p {
      position: absolute;
      width: 100%;
      line-height: 28px;
      height: 28px;
      color: #fff;
      text-align: center;
      font-size: 14px;
      bottom: 0;
      background: rgba(37, 37, 37, 0.8);
    }
    img {
      width: 162px;
      height: 114px;
    }
  }
  .btn {
    width: 150px;
    line-height: 45px;
    height: 45px;
    text-align: center;
    border: 1px solid #cfcfcf;
    font-size: 20px;
    color: #333;
    cursor: pointer;
    margin: 40px auto 0;
    &:hover {
      opacity: 0.9;
    }
    &.confirm {
      color: #fff;
      background: #333;
      border-color: #333;
    }
  }
  .detail-y {
    padding-right: 30px;
    margin-top: 30px;
    height: 250px;
    overflow: auto;
    .flex-column {
      position: absolute;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      width: 18px;
      margin-left: 58px;
      transform: translateY(2px);
      /*min-height: 80px;*/
    }
    .dot {
      position: relative;
      height: 19px;
      width: 19px;
      border-radius: 19px;
      background: #dbdbdb;
      &:after {
        display: inline-block;
        content: '';
        height: 13px;
        width: 13px;
        border-radius: 13px;
        background-color: #666;
        position: absolute;
        top: 3px;
        left: 3px;
      }
      &.active {
        background: #ffd9d8;
        &:after {
          background-color: #df3d36;
        }
      }
    }
    .title {
      font-size: 18px;
      color: #333;
    }
    .time {
      font-size: 13px;
      margin: 8px 0 15px 0;
      color: #999;
    }
    .list-item {
      position: relative;
      padding-left: 103px;
      /*align-items: start;*/
    }
    .list {
      background: #fff;
    }
    .line {
      position: relative;
      /*height: 100%;*/
      // width: 2px
      border-left: 2px solid #e0e0e0;
    }
  }
}
</style>
